import type { CityConfig } from "@/pages/city-template/types";

export const theDallesConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Oregon Vital Records (Birth, Death, Marriage)", desc: "Request certified birth, death, and marriage certificates from Oregon Vital Records.", url: "https://www.oregon.gov/oha/PH/BirthDeathCertificates/Pages/index.aspx" },
    { icon: "ri-government-line", label: "Wasco County Clerk Vital Records", desc: "Obtain vital records through the Wasco County Clerk's office in The Dalles.", url: "https://www.co.wasco.or.us/" },
    { icon: "ri-global-line", label: "VitalChek — Order Vital Records Online", desc: "Official online ordering partner of Oregon Vital Records for certified certificates.", url: "https://www.vitalchek.com/" },
  ],
  city: "The Dalles",
  state: "Oregon",
  stateAbbr: "OR",
  slug: "the-dalles",
  route: "/cities/the-dalles",
  title: "Emergency Passport The Dalles, OR | Expedited Passport Services Columbia River Gorge",
  metaDescription: "Emergency passport and expedited passport services in The Dalles, OR — as fast as 24 hours. Serving Wasco County, Columbia River Gorge, Hood River, and Maupin. A+ BBB rated registered State Dept. courier. Rush passport renewal for The Dalles travelers.",
  h1: "Emergency & Expedited Passport Services in The Dalles, Oregon",
  heroSubtitle: "Passport expired before your Canada border crossing or European trip? Fast Passport Center helps The Dalles and Columbia River Gorge travelers get expedited passports in as little as 24 hours. Wasco County's trusted passport courier — start online, ship overnight from The Dalles or Hood River.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Columbia%20River%20Gorge%20dramatic%20landscape%20near%20The%20Dalles%20Oregon%20with%20high%20desert%20hills%20and%20wide%20river%20views%2C%20golden%20hour%20warm%20light%20on%20rolling%20wheat%20fields%20and%20basalt%20cliffs%2C%20sweeping%20panoramic%20vista%20with%20bright%20sky%20and%20rich%20earthy%20tones%2C%20photorealistic%20landscape%20with%20deep%20contrast%20and%20vibrant%20colors%2C%20no%20text%20or%20signs%20visible%2C%20pacific%20northwest%20scenic%20beauty&width=1800&height=700&seq=the-dalles-hero-01&orientation=landscape",
  heroImageAlt: "Columbia River Gorge near The Dalles Oregon with dramatic cliffs and river views",
  geoPosition: "45.5946;-121.1787",
  geoPlacename: "The Dalles, Oregon",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "About 200 miles northwest — 3.5 hours by car",
  },
  nearbyCitiesZips: [
    { name: "The Dalles", zips: "97058" },
    { name: "Hood River", zips: "97031" },
    { name: "Mosier", zips: "97040" },
    { name: "Rowena", zips: "97058" },
    { name: "Maupin", zips: "97037" },
    { name: "Dufur", zips: "97021" },
    { name: "Goldendale", zips: "98620" },
    { name: "White Salmon", zips: "98672" },
    { name: "Bingen", zips: "98605" },
    { name: "Stevenson", zips: "98648" },
    { name: "Cascade Locks", zips: "97014" },
    { name: "Parkdale", zips: "97041" },
    { name: "Portland (east)", zips: "97230, 97236" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit required. Complete your expedited passport order from your home or office in The Dalles or anywhere in Wasco County." },
    { icon: "ri-truck-line", title: "Overnight Shipping from The Dalles", desc: "FedEx and UPS locations in The Dalles and Hood River offer overnight shipping to our processing center. Most are open evenings and weekends." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application receives a professional review before submission — critical for remote Wasco County applicants who can't afford a rejection." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved daily submission slots at the nearest regional passport agency — bypassing the public appointment system." },
  ],
  testimonials: [
    {
      name: "Craig W.",
      location: "The Dalles, OR",
      rating: 5,
      text: "My wife and I were planning a Canada trip and her passport had expired. Fast Passport Center was the only option that made sense from The Dalles. They renewed it in 6 days. Shipped from the UPS in The Dalles and got it back with plenty of time.",
      service: "Passport Renewal",
    },
    {
      name: "Diane H.",
      location: "Hood River, OR",
      rating: 5,
      text: "Our family needed emergency passports for a last-minute trip to British Columbia. Fast Passport Center got three passports processed in 5 days. Outstanding service — I was nervous being this far from a passport office.",
      service: "Emergency Passport",
    },
    {
      name: "Marcus T.",
      location: "Mosier, OR",
      rating: 5,
      text: "First time getting a passport at age 52. Fast Passport Center walked me through exactly what the post office needed and handled everything after. Clear, professional, and fast. I'll use them again.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "dalles-post",
      name: "The Dalles Post Office",
      type: "USPS Passport Acceptance",
      address: "1012 E 14th St",
      city: "The Dalles",
      state: "OR",
      zip: "97058",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Primary location — downtown The Dalles",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Primary passport acceptance facility for Wasco County. Appointment required. Call ahead to confirm availability — scheduling can be limited.",
      icon: "ri-mail-line",
    },
    {
      id: "hood-river-post",
      name: "Hood River Post Office",
      type: "USPS Passport Acceptance",
      address: "408 Cascade Ave",
      city: "Hood River",
      state: "OR",
      zip: "97031",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Hood River — about 20 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Hood River option for western Wasco County and Columbia Gorge residents. Often has better appointment availability than The Dalles.",
      icon: "ri-mail-line",
    },
    {
      id: "wasco-county-clerk",
      name: "Wasco County Clerk",
      type: "County Passport Acceptance",
      address: "511 Washington St",
      city: "The Dalles",
      state: "OR",
      zip: "97058",
      phone: "541-506-2530",
      hours: "Mon–Fri 8am–5pm (by appointment)",
      distance: "Downtown The Dalles — County Courthouse",
      website: "https://www.co.wasco.or.us/",
      websiteLabel: "Wasco County Website",
      notes: "County clerk passport acceptance. Appointment required — call to verify current passport services and availability.",
      icon: "ri-government-line",
    },
    {
      id: "goldendale-post",
      name: "Goldendale Post Office (WA)",
      type: "USPS Passport Acceptance",
      address: "110 E Main St",
      city: "Goldendale",
      state: "WA",
      zip: "98620",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "Goldendale, WA — about 25 miles north across the river",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Washington state option for northern Gorge residents. Washington applicants use the same U.S. passport application forms.",
      icon: "ri-mail-line",
    },
    {
      id: "cascade-locks-post",
      name: "Cascade Locks Post Office",
      type: "USPS Passport Acceptance",
      address: "130 NW Portage Rd",
      city: "Cascade Locks",
      state: "OR",
      zip: "97014",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–3pm",
      distance: "Cascade Locks — about 40 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Small branch serving western Columbia Gorge communities. Limited hours — call ahead before driving.",
      icon: "ri-mail-line",
    },
    {
      id: "white-salmon-post",
      name: "White Salmon Post Office (WA)",
      type: "USPS Passport Acceptance",
      address: "120 NW Jewett Blvd",
      city: "White Salmon",
      state: "WA",
      zip: "98672",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "White Salmon, WA — about 22 miles west across the Bridge of the Gods",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Washington option for Gorge residents on the WA side. U.S. passport applications accepted regardless of state.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport in The Dalles, Oregon?",
      a: "Yes. Through Fast Passport Center, The Dalles travelers can get an emergency passport in as fast as 24 hours. The Dalles does not have a regional passport agency, but our registered courier service submits through reserved agency channels in Seattle. Start your order online today — we guide you through the entire process from Wasco County.",
    },
    {
      q: "How do I expedite a passport renewal from The Dalles, OR?",
      a: "Expedited passport renewal from The Dalles is straightforward with Fast Passport Center. Most renewals are eligible to apply entirely by mail — no in-person acceptance visit required. Complete your order online, ship your documents overnight from The Dalles UPS or FedEx location, and we handle the rest. Processing can be as fast as 2–9 business days.",
    },
    {
      q: "Is The Dalles, OR close to a passport agency?",
      a: "The Dalles is not near a U.S. regional passport agency. The closest is the Seattle Passport Agency, about 200 miles northwest (a 3.5-hour drive). That agency requires a documented appointment and proof of travel within 14 days. Fast Passport Center is a significantly faster and more convenient option for most Wasco County residents.",
    },
    {
      q: "Where can I apply for a passport in The Dalles, Oregon?",
      a: "Passport acceptance facilities near The Dalles include the USPS post offices in The Dalles, Hood River, and Mosier, as well as the Wasco County Clerk's office. However, applying through a post office means waiting 6–13 weeks for standard processing. If you need your passport faster, use Fast Passport Center's expedited courier service.",
    },
    {
      q: "Can I get a passport photo in The Dalles, OR?",
      a: "Yes. Passport photos near The Dalles are available at the Walgreens on West 2nd Street, as well as at some UPS and FedEx locations in Hood River. Make sure your photo is on plain white or off-white background with correct sizing — we'll send you the exact specifications when you start your order.",
    },
    {
      q: "What is the fastest way to get a passport in Wasco County, Oregon?",
      a: "The fastest way to get a passport in Wasco County is to use Fast Passport Center's registered courier service. We offer processing as fast as 24 hours for emergency cases. Driving to the Seattle agency yourself (200 miles away) only works for documented emergencies and can take all day. Our service is faster, more predictable, and doesn't require a road trip.",
    },
    {
      q: "Can I get an expedited passport for a Canada border crossing from The Dalles?",
      a: "Absolutely. Canada requires a valid U.S. passport (or NEXUS card) for air travel — and for land crossings, a passport or enhanced driver's license is strongly recommended. If your passport is expired or expiring soon before a Canada trip from The Dalles, start your expedited renewal now. Fast Passport Center can process it in as little as 3 business days.",
    },
    {
      q: "Can I get a child passport from The Dalles, OR?",
      a: "Yes. Child passports (for minors under 16) require an in-person acceptance visit at a passport acceptance facility with both parents (or documented exceptions). We provide a complete checklist for the acceptance visit and handle the expedited processing after your documents are submitted. Our process is clear even for first-time applicants in rural areas like Wasco County.",
    },
    {
      q: "What if I need a passport urgently for a hunting or fishing trip to Canada?",
      a: "This is one of the most common urgent requests we get from Eastern Oregon and Columbia Gorge hunters and anglers. If your BC hunting or fishing trip is coming up and your passport is expired, don't wait. Fast Passport Center can expedite your renewal in as little as 2–9 business days. The earlier you start, the more options you have.",
    },
    {
      q: "How long does a standard passport take from The Dalles, Oregon?",
      a: "Standard passport processing from The Dalles through USPS typically takes 6–13 weeks — and sometimes longer during peak season (spring and summer). If your travel is within 10 weeks, you need expedited processing. Fast Passport Center offers The Dalles travelers processing as fast as 24 hours for emergency situations.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — The Dalles", address: "1000 W 2nd St, The Dalles, OR 97058", hours: "Daily 8 AM – 9 PM" },
    { name: "The UPS Store — Hood River", address: "309 Portway Ave, Hood River, OR 97031", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 4 PM" },
    { name: "FedEx — Hood River", address: "1003 E Marina Way, Hood River, OR 97031", hours: "Mon–Fri 8 AM – 7 PM" },
    { name: "Safeway Pharmacy — The Dalles", address: "901 W 2nd St, The Dalles, OR 97058", hours: "Mon–Fri 9 AM – 8 PM, Sat–Sun 10 AM – 6 PM" },
    { name: "Rite Aid — The Dalles", address: "615 E 2nd St, The Dalles, OR 97058", hours: "Daily 8 AM – 9 PM" },
    { name: "Walmart — The Dalles", address: "3223 W 6th St, The Dalles, OR 97058", hours: "Daily 7 AM – 11 PM" },
    { name: "Walgreens — Hood River", address: "801 12th St, Hood River, OR 97031", hours: "Daily 8 AM – 9 PM" },
    { name: "FedEx Office — Gresham", address: "501 NW Burnside Rd, Gresham, OR 97030", hours: "Mon–Fri 8 AM – 8 PM" },
    { name: "Costco Photo — Gresham", address: "1675 NW Civic Dr, Gresham, OR 97030", hours: "Mon–Fri 10 AM – 8:30 PM" },
    { name: "CVS — Troutdale", address: "740 SE Crown Point Hwy, Troutdale, OR 97060", hours: "Daily 7 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "The Dalles Driver & Motor Vehicle Services",
      address: "1545 E 2nd St, The Dalles, OR 97058",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Primary Wasco County DMV office. Driver licenses, REAL ID, state IDs. Appointment recommended.",
      featured: true,
    },
    {
      name: "Hood River Driver & Motor Vehicle Services",
      address: "Hood River, OR 97031",
      hours: "Limited hours — call ahead",
      note: "Hood River DMV option for western Gorge residents. Hours vary seasonally.",
      featured: false,
    },
    {
      name: "Gresham Driver & Motor Vehicle Services",
      address: "885 NE Division Dr, Gresham, OR 97030",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Larger Gresham/Portland DMV office if you need REAL ID with full service availability.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PDX",
      name: "Portland International Airport",
      distance: "Primary international airport — about 80 miles west via I-84",
      address: "7000 NE Airport Way, Portland, OR 97218",
      note: "PDX is the primary airport for The Dalles and Wasco County travelers needing international flights. The I-84 drive takes approximately 1.5 hours from The Dalles — plan ahead for early morning departures. PDX offers direct international flights to Europe, Asia, Mexico, and Canada.",
      flightUrl: "https://www.flypdx.com/",
      flightLabel: "PDX Airport Website",
      featured: true,
    },
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "Alternative hub — about 200 miles northwest via I-84/I-5",
      address: "17801 International Blvd, SeaTac, WA 98158",
      note: "Some Wasco County travelers use SEA for broader flight options. Both airports require a valid U.S. passport for international departure.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Airport Website",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Departing from PDX within 24–72 hours and your passport is expired or lost? Fast Passport Center handles emergency passport processing for The Dalles and all of Wasco County — including rural addresses and remote Columbia Gorge communities.",
      bullets: ["As fast as 24 hours", "Emergency lost passport replacement", "Reserved agency slots — no public appointment"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Expedited Passport Renewal",
      description: "The most common service for The Dalles area residents. Passport expired before a Canada trip, British Columbia hunting season, or PDX international departure? We expedite renewals with no office visit required.",
      bullets: ["No in-person visit for most renewals", "Ship overnight from The Dalles or Hood River", "Processing in as little as 3 business days"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost Passport Replacement",
      description: "Lost your passport before a Gorge trip to B.C. or a PDX international departure? We guide The Dalles travelers through DS-64 and expedited replacement processing.",
      bullets: ["DS-64 form guidance included", "Urgent replacement available", "Wasco County pickup/ship options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Child passports for Wasco County families — minors require in-person acceptance with parental consent. We provide clear step-by-step instructions for The Dalles area parents.",
      bullets: ["Both parents typically required", "Step-by-step checklist provided", "Expedited after acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport (First-Time)",
      description: "First passport for Wasco County adults or children. We guide you through the in-person acceptance step at The Dalles or Hood River post office and handle expedited processing from there.",
      bullets: ["Acceptance clerk guidance included", "Clear checklist — no guesswork", "Expedited processing after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line",
      title: "Registered Courier Service",
      description: "Fast Passport Center is a registered U.S. Department of State passport courier. We submit through reserved agency channels — not public lines — giving The Dalles travelers access to the fastest available processing.",
      bullets: ["State Dept. registered courier", "Reserved daily submission slots", "Not impacted by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change, Damaged & Second Passports",
      description: "Passport name changes after marriage or divorce, damaged passport replacement, and second passports for frequent international travelers — all available with the same expedited courier access.",
      bullets: ["Name change after marriage/divorce", "Damaged passport replacement", "Second passport for frequent travel"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for The Dalles, Oregon travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Expedited Passport Renewal", description: "Fast expedited passport renewal for The Dalles, OR residents — processing in as little as 3 business days." },
    { name: "Passport Courier Service", description: "Registered U.S. Department of State courier passport service serving The Dalles and Wasco County, Oregon." },
    { name: "Lost Passport Replacement", description: "Emergency passport replacement for The Dalles travelers with lost or stolen passports." },
    { name: "Child Passport", description: "Expedited child passport services for Wasco County families with minors under 16." },
    { name: "New Passport Application", description: "First-time passport application assistance for The Dalles, OR residents." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Underestimating Processing Time", description: "Standard passport applications out of The Dalles take 6–13 weeks. With PDX being 80 miles away and Canada just a few hours north, The Dalles travelers often assume passports come faster. They don't. Apply well before your trip." },
    { icon: "ri-camera-off-line", title: "Rejected Passport Photos", description: "Photos that are too dark, have shadows, or wrong background are the #1 cause of delays. We send exact specifications — and recommend Walgreens or a FedEx office rather than phone selfies." },
    { icon: "ri-file-damage-line", title: "Incomplete Forms", description: "A single missing date or signature on the DS-11 or DS-82 form can send your application back weeks later. Fast Passport Center reviews your documents before submission." },
    { icon: "ri-pen-nib-line", title: "Wrong Birth Certificate", description: "Some birth certificates — especially for people born in rural Eastern Oregon — require long-form certified copies with a raised seal. We'll tell you exactly what you need." },
    { icon: "ri-calendar-close-line", title: "Waiting for the Post Office", description: "The Dalles USPS passport acceptance is limited. Don't wait for an appointment slot that's 3 weeks out when your Canada hunting trip is in 4 weeks. Use Fast Passport Center instead." },
    { icon: "ri-map-pin-time-line", title: "Name Mismatch on Ticket vs. Passport", description: "Your passport name must exactly match your flight booking. Middle names, hyphens, and name changes after marriage cause problems at PDX and international borders." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your travel date from The Dalles. Complete your secure order in minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Checklist", description: "We send you a personalized document checklist — exactly what you need, tailored to your situation in Wasco County." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Overnight from The Dalles", description: "Drop off at UPS or FedEx in The Dalles or Hood River. Most are open evenings and weekends for your convenience." },
    { number: "04", icon: "ri-building-2-line", title: "Reserved Agency Submission", description: "We submit through our reserved passport agency slots — no public appointment needed. Your case gets priority." },
    { number: "05", icon: "ri-passport-line", title: "Passport Delivered to You", description: "Your completed passport is shipped directly back to your address in The Dalles or anywhere in Wasco County." },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Life-or-death emergencies only",
        "Requires appointment at Seattle agency (200 miles away)",
        "No walk-ins — strict eligibility",
        "Expect to wait all day at agency",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission — no public lines",
        "Predictable turnaround for Wasco County travelers",
        "Document review included",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
        "Ship overnight from The Dalles or Hood River",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Faster than USPS self-service",
        "Good for planned international travel",
        "Document review included",
        "Dedicated agent assigned",
        "Daily status updates",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access",
        "Appointment availability limited in Wasco County",
        "No document review — errors cause rejection",
        "No dedicated agent",
        "Updates only by mail",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Seattle agency, 200 miles away", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Must drive to Seattle (3.5 hours each way)", fpc: "Ship overnight from The Dalles or Hood River" },
    { feature: "Processing Speed", agency: "Emergency travel only — strict eligibility", fpc: "As fast as 24 hours — multiple speed tiers" },
    { feature: "Document Review", agency: "None — rejections cause weeks of delay", fpc: "Professional review before submission" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission slots" },
    { feature: "Rural Applicant Support", agency: "No support — you are on your own", fpc: "Dedicated agent for every Wasco County case" },
    { feature: "Government Shutdowns", agency: "Operations may be suspended", fpc: "Not affected" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Emergency passport services in Hood River", route: "/cities/hood-river" },
    { name: "Expedited passport help in Portland", route: "/cities/portland" },
    { name: "Rush passport renewal in Bend", route: "/cities/bend" },
    { name: "Fast passport services in Gresham", route: "/cities/gresham" },
    { name: "Oregon expedited passport guide", route: "/states/oregon" },
  ],
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeNote: "After starting your order online, we send your personalized document checklist and shipping instructions. Ship overnight from The Dalles UPS or FedEx in Hood River — no in-person visit to our facility required.",
  fpcOfficeDistance: "Serving The Dalles and all of Wasco County remotely",
  serviceAreaIntro: "Whether you are in The Dalles, Hood River, Mosier, Maupin, Dufur, or anywhere in the Columbia River Gorge, Fast Passport Center makes expedited passport services accessible from remote Oregon. No office visit required.",
  nearbyCitiesIntro: "We serve all Wasco County zip codes plus the Washington side of the Gorge. Ship overnight and your documents are at our processing center the next morning.",
  howItWorksIntro: "Getting an expedited passport from The Dalles is easier than you think. Start online, ship from your local UPS or FedEx, and we handle the rest.",
  mistakesIntro: "These mistakes cause the most delays and rejections for Eastern Oregon and Columbia Gorge travelers. Fast Passport Center reviews your documents before submission to catch these issues early.",
  testimonialsIntro: "Real reviews from The Dalles, Hood River, and Columbia Gorge travelers who needed their passports fast.",
  faqIntro: "The most common questions from Wasco County and Columbia Gorge residents about emergency and expedited passport services.",
  statePageRoute: "/states/oregon",
  statePageName: "Oregon",
  travelTiming: {
    title: "Travel Timing & Passport Urgency for The Dalles Residents",
    intro: "The Dalles sits at the crossroads of Eastern Oregon, the Columbia River Gorge, and easy access to British Columbia. These travel patterns create predictable passport urgencies for Wasco County residents — and we've helped hundreds of Gorge-area travelers navigate them.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "PDX Airport — 80 Miles West on I-84",
        subtitle: "About 1.5 hours from The Dalles",
        description: "Portland International Airport is the primary gateway for The Dalles and Wasco County travelers heading internationally. The 80-mile I-84 drive is straightforward but requires planning for early morning departures. PDX offers direct international flights to Europe (Amsterdam, London, Reykjavik), Asia (Tokyo, Seoul), Canada (Vancouver), and Latin America. Many Gorge-area residents book international trips without checking their passport expiration until the week before — leaving very little time for standard processing.",
        tip: "Check your passport expiration as soon as you book any international flight through PDX. A passport expiring within 6 months of your return date may be rejected at the border of many countries. Don't leave it until the day before.",
      },
      {
        icon: "ri-map-pin-2-line",
        title: "Canada Border Crossings & B.C. Recreation",
        subtitle: "Vancouver, B.C., Okanagan, Interior B.C.",
        description: "The Canadian border is accessible from The Dalles via several routes — and British Columbia is one of the most popular destinations for Columbia Gorge residents. Hunting, fishing, skiing, and family visits to Vancouver and the Okanagan Valley drive consistent passport demand from Wasco County. The B.C. hunting and fishing seasons (August–November) create a predictable spike in urgent passport requests — often from hunters who don't realize their passport expired until they're about to book their licenses.",
        tip: "For BC hunting or fishing trips, valid U.S. passport required for border crossing. NEXUS cards and enhanced driver's licenses also work for land crossings, but a passport is the safest option. Check expiration well before your trip date.",
      },
      {
        icon: "ri-leaf-line",
        title: "Columbia Gorge Outdoor & Wine Tourism",
        subtitle: "Mt. Hood, Rowena Plateau, Gorge wine trail",
        description: "The Columbia River Gorge attracts a mix of outdoor adventurers, wind sports enthusiasts, and wine tourism visitors who often combine local recreation with international travel. Hood River-area kiteboard and windsurf enthusiasts frequently plan trips to Baja Mexico, the Canary Islands, and Spain — sports-focused international travel that often has rigid booking timelines. Gorge wine industry workers also travel to France and Germany for trade events.",
        tip: "Baja Mexico and the Canary Islands are top kite/windsurf destinations for Gorge athletes. Both require a valid U.S. passport. Mexico requires 6 months validity beyond your return date. Plan passport renewal before booking Baja flights.",
      },
      {
        icon: "ri-briefcase-line",
        title: "Eastern Oregon Business & Agricultural Travel",
        subtitle: "Pacific Rim agriculture, tech sector, export business",
        description: "The Dalles is home to large data centers (Google, Amazon) and significant agricultural export operations. Tech employees frequently travel internationally for conferences and business meetings — often on short notice. Agricultural businesses export grain, cherries, and other products to Japan, South Korea, and the Pacific Rim, requiring travel for trade negotiations and inspections with compressed timelines.",
        tip: "Tech sector and agricultural export travel to Japan and South Korea often requires applying for a Japan visa or K-ETA in advance. Both require a valid passport — if yours is expiring within 12 months, renew before applying for any visas.",
      },
    ],
    callout: {
      icon: "ri-shield-star-line",
      title: "Remote Oregon Travelers — We've Got You Covered",
      description: "Living in Wasco County or the Columbia River Gorge means you are far from a regional passport agency. Fast Passport Center was built for exactly this situation — remote applicants who can't afford the time or expense of driving to Seattle. Our registered courier service brings the passport agency to you. Start online, ship from The Dalles or Hood River, and we handle everything else.",
    },
  },
  destinations: {
    title: "Where The Dalles Travelers Go — And Why Passports Get Urgent",
    intro: "These are the destinations and travel patterns we see most from Wasco County and Columbia Gorge clients. Understanding local travel behavior helps us anticipate the passport urgencies that arise here.",
    stats: [
      { stat: "80 Mi", label: "from The Dalles to PDX — the nearest international airport for Gorge residents" },
      { stat: "B.C. Season", label: "Aug–Nov hunting and fishing season drives the largest spike in Wasco County passport urgency" },
      { stat: "2–3 Wks", label: "typical notice The Dalles travelers have when they discover an expired passport before a trip" },
      { stat: "6 Months", label: "minimum passport validity required for Mexico, Japan, and most European countries" },
    ],
    destinations: [
      {
        name: "British Columbia, Canada",
        context: "Hunting, fishing, skiing, family visits to Vancouver and the Okanagan Valley — the top international destination for Wasco County residents",
        urgency: "B.C. hunting and fishing season licenses prompt last-minute passport discoveries Aug–Nov",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Mexico (Baja & Pacific Coast)",
        context: "Kiteboarding and windsurfing trips to Baja California and the Pacific coast — popular among Hood River Gorge sports community",
        urgency: "Kite and windsurf bookings are often weather-dependent and confirmed 1–3 weeks out",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Japan & South Korea",
        context: "Pacific Rim agricultural trade, tech business travel for The Dalles data center employees, and cherry export industry trips",
        urgency: "Business travel and trade show attendance often has 2–4 week notice; Japan visa requires valid passport",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Europe (France, Spain, Germany)",
        context: "Wine industry travel to Burgundy and Alsace, kite/windsurf trips to the Canary Islands and Tarifa, tech conference travel",
        urgency: "ETIAS electronic travel authorization (coming 2025+) will require pre-registration with a valid passport",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Alaska",
        context: "Hunting, fishing, and adventure travel from the Gorge — some Eastern Oregon travelers drive to Seattle to join Alaska cruises",
        urgency: "Alaska cruise bookings often finalized 3–6 weeks before departure; passports must be valid",
        icon: "ri-map-pin-2-line",
      },
      {
        name: "Costa Rica & Central America",
        context: "Eco-tourism, zip-line adventures, and retirement scouting trips popular among Columbia Gorge retirees and outdoor enthusiasts",
        urgency: "Winter bookings (Dec–Feb) often confirmed just weeks in advance; Costa Rica requires 6 months passport validity",
        icon: "ri-map-pin-2-line",
      },
    ],
    crossLinksTitle: "Explore Other Columbia Gorge & Eastern Oregon Service Areas",
    crossLinksDesc: "We serve travelers throughout the Columbia River Gorge and Eastern Oregon with the same expedited passport processing expertise.",
    crossLinks: [
      { name: "Hood River", route: "/cities/hood-river" },
      { name: "Bend", route: "/cities/bend" },
      { name: "Portland", route: "/cities/portland" },
    ],
  },
};